import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Filteredusers(state = initialState, action) {
  switch (action.type) {
    case userConstants.FILTEREDUSERS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.FILTEREDUSERS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.FILTEREDUSERS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}